import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';

import {
  Permissions,
  UserPermissions,
  hasPermissionForListId,
} from '®shared/permissions';
import { ReadingListDetails, Section } from '®shared/reading-list';
import { PeriodStatus } from '®shared/tenant';
import { UriService } from '®shared/url-utils';

@Component({
  selector: 'rl-section-alerts',
  templateUrl: './section-alerts.component.html',
})
export class SectionAlertsComponent implements OnInit {
  @Input() list: ReadingListDetails;
  @Input() permissions: UserPermissions;
  @Input() rolledOverTo: Section;

  hasEditListPermission: boolean;
  hasTimePeriodExpired = false;
  hasTimePeriodNotStarted = false;

  private now = new Date();

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private uriService: UriService,
  ) {}

  ngOnInit(): void {
    this.hasEditListPermission = hasPermissionForListId(
      Permissions.EDIT_LIST,
      this.list.id,
      this.permissions,
    );

    if (this.list.period) {
      const periodStatus = this.list.period.status(this.now);
      this.hasTimePeriodExpired = periodStatus === PeriodStatus.PAST;
      this.hasTimePeriodNotStarted = periodStatus === PeriodStatus.FUTURE;
    } else {
      this.hasTimePeriodExpired = false;
      this.hasTimePeriodNotStarted = false;
    }
  }

  getSectionUrl(sectionId: string): string {
    return this.uriService.getSectionUrl(sectionId);
  }
}
